import Vue from 'vue'
import config from '@/config'
import store from '@/store'
import Branding from '@/components/mixins/Branding'
import priceFormat from '@/library/priceFormat'
import hcpFormat from '@/library/hcpFormat'
import tsStart from '@/components/common/tsStart.vue'
import killswitch from '@/components/mixins/killswitch'

export default {
  name: 'SelectionRegular',

  mixins: [
    Branding,
    killswitch
  ],

  props: ['id', 'currentBetSlipState', 'tab', 'allowedBetTypesAndReturns', 'parlayStake', 'betsNo', 'allowedMultiSingles'],

  components: {
    tsStart
  },

  data () {
    return {
      allowedBetTypesAndReturn: {},
      stateLimitToUpdate: 2,
      priceUp: false,
      priceDown: false,
      hcpUp: false,
      hcpDown: false,
      doNotMarkChanges: false,
      timeOuts: {},
      timeOutsDrv: {},
      changed: {price: 0, currenthandicap: 0},
      triggeredBetSlipUpdate: false,
      triggeredPopularParlaysUpdate: false
    }
  },

  computed: {
    selection () {
      return this.id ? store.getters['sbBetslipState/getStoredSelectionById'](this.id) : {}
    },
    idFoSelection () {
      return this.id && this.selection && this.selection.idfoselection
    },
    derivativeSelection () {
      var tab = this.isSGM ? 'REGULAR' : this.tab
      return tab !== 'TEASER' && this.id ? store.getters['sbBetslipState/getDerivative'](this.id, tab) : {}
    },
    derivativeId () {
      return this.derivativeSelection && this.derivativeSelection.idfoselection
    },
    optedIn: {
      // getter
      get: function () {
        return store.getters['sbBetslipState/optedIn'][this.tab]
      },
      // setter
      set: function (newValue) {
//          console.log('selected newValue: ' + newValue)
      }
    },
    showCheckbox () {
      return store.getters['sbBetslipState/betslipCheckboxesForSelections'][this.tab]
    },
    isLive () {
      return this.id && this.idfoevent ? store.getters['sbBetslipState/isEventLive'](this.idfoevent) : false
    },
    // liveWireEvents () {
      // return store.getters['sbBetslipState/liveWireEvents']
    // },
    isLiveWireEvent () {
      return this.id && this.idfoevent ? store.getters['sbBetslipState/isLiveWireEvent'](this.idfoevent, this.idfomarket) : false
    },
    liveBettingDataSourceType () {
      return store.getters['livebettingState/liveBettingDataSourceType']
    },
    liveSelection () {
      return this.id && this.selection ? store.getters['sbBetslipState/getSelectionById'](this.id) : {}
    },
    idfomarket () {
      return store.getters['sbBetslipState/getIdfoMarketById'](this.id)
    },
    idfoevent () {
      return store.getters['sbBetslipState/getIdfoEventById'](this.id)
    },
    market () {
      return this.id && this.selection ? store.getters['sbBetslipState/getStoredMarketById'](this.id) : {}
    },
    marketName () {
      return this.id && ((this.derivativeSelection && this.derivativeSelection.market) || (this.market && this.market.name))
    },
    selectionMarketName () {
      return this.id && ((this.market && this.market.name) || '')
    },
    derivativeMarketName () {
      return this.id && ((this.derivativeSelection && this.derivativeSelection.market) || '')
    },
    eventName () {
      return this.id && this.market && this.market.eventname
    },
    selectionName () {
      return this.id && this.selection && this.selection.name
    },
    pitcherNames () {
      return (this.market &&
        !this.market.isoutright &&
        this.market.idfosporttype === 'BASEBALL' &&
        // this.market.derivativetypes && this.market.derivativetypes.indexOf('PP') > -1 &&
        // this.market.pitcherhacode !== 'AP' &&
        this.market.awaypitchername && this.market.homepitchername &&
        {'awaypitchername': this.market.awaypitchername, 'homepitchername': this.market.homepitchername}) || false
    },
    canBePlacedAsSingle () {
      let betType = (this.allowedBetTypesAndReturn && this.allowedBetTypesAndReturn.BetType) || 'S'
      return this.tab === 'REGULAR' &&
        (this.allowedMultiSingles || (!this.allowedMultiSingles && this.betsNo === 1)) &&
        this.id && this.selection && this.selection.csvavailablebettypes && this.selection.csvavailablebettypes.includes(betType)
    },
    price () {
      var p
      var selection = this.derivativeSelection &&
        this.derivativeSelection.currentpricedown &&
        this.derivativeSelection.currentpriceup ? this.derivativeSelection : this.selection
        // && (!this.derivativeSelection.derivativetype || this.derivativeSelection.derivativetype === 'HP') ? this.derivativeSelection : this.selection
      //
//        p = this.selection && this.selection.price
      if (selection && selection.currentpricedown && selection.currentpriceup) {
        p = this.formatSelectionPrice(selection)
      }
      return p
    },
    priceValue () {
      return this.id && this.priceFormatted && parseFloat(this.priceFormatted)
    },
    priceLive () {
      var p = 0
      if (!this.currentBetSlipState && this.id && this.liveSelection && this.liveSelection.idfoselection) {
        let selection = this.liveSelection
        p = selection && selection.price
        if (selection.currentpricedown && selection.currentpriceup) {
          p = this.formatSelectionPrice(selection)
        } else {
          p = priceFormat.formatOdds(p)
        }
        return parseFloat(p)
      }
    },
    handicap () {
      var selection = this.derivativeSelection && this.derivativeSelection.currentmatchhandicap ? this.derivativeSelection : this.selection
      return this.id && selection && hcpFormat.formatHandicap(selection)
    },
    handicapLive () {
      return !this.currentBetSlipState && this.id && this.liveSelection && this.liveSelection.idfoselection && hcpFormat.getHandicap(this.liveSelection, true)
    },
    handicapValue () {
      return this.id && this.handicapFormatted && parseFloat(this.handicapFormatted)
    },
    marketLiveWire () {
      return this.id ? store.getters['sbBetslipState/getMarketById'](this.id) : {}
    },
    activepricetypesLW () {
      return (this.isLive || this.isLiveWireEvent) && !this.currentBetSlipState ? this.marketLiveWire && this.marketLiveWire.activepricetypes : undefined
    },
    csvpricetypes () {
      return this.selection && this.selection.csvpricetypes
    },
    clearMarkings () {
      return store.getters['sbBetslipState/clearMarkings']
    },
    isSuspendedViaKilswitch () {
      return this.isLive || this.isLiveWireEvent ? this.ksIsMarketSuspended(this.marketLiveWire) : this.ksIsMarketSuspended(this.market)
    },
    idfoselectionsuspensiontype () {
      // console.log('idfoselectionsuspensiontype')
      let selection = (this.derivativeSelection && this.derivativeSelection.active && this.derivativeSelection) || this.liveSelection || this.selection
      return selection && selection.idfoselectionsuspensiontype
    },
    nontradableon () {
      return this.selection && this.selection.nontradableon
    },
    hiddenfrom () {
      return this.selection && this.selection.hiddenfrom
    },
    businessChannel () {
      return config && config.app && config.app.businessChannel
    },
    isSuspendedBySuspensiontype () {
      return (this.idfoselectionsuspensiontype && this.businessChannel &&
        ((this.idfoselectionsuspensiontype.split(',').includes(this.businessChannel) && this.businessChannel) ||
          (this.idfoselectionsuspensiontype.split(',').includes('N/O') && 'N/O')))
    },
    isSuspendedByNontradableon () {
      return (this.nontradableon && this.businessChannel &&
        ((this.nontradableon.split(',').includes(this.businessChannel) && this.businessChannel) ||
          (this.nontradableon.split(',').includes('N/O') && 'N/O')))
    },
    isSuspendedByHiddenfrom () {
      return (this.hiddenfrom && this.businessChannel &&
        ((this.hiddenfrom.split(',').includes(this.businessChannel) && this.businessChannel) ||
          (this.hiddenfrom.split(',').includes('N/O') && 'N/O')))
    },
    selectionHasSuspensionPerBusinessChannel () {
      return !!(this.isSuspendedBySuspensiontype || this.isSuspendedByNontradableon || this.isSuspendedByHiddenfrom)
    },
    isNR () {
      let selection = this.isLive ? this.liveSelection : this.selection
      return selection && selection.idfobolifestate && selection.idfobolifestate === 'NR'
    },
    isSuspendedByCalc () {
      return !!(this.allowedBetTypesAndReturn &&
        ((this.allowedBetTypesAndReturn.Status && this.allowedBetTypesAndReturn.Status === 'SUSPENDED') ||
          this.allowedBetTypesAndReturn.PotentialReturn === 0 ||
          this.allowedBetTypesAndReturn.UnitCount === 0))
    },
    isClosedLW () {
//        return this.selection && this.selection.isclosed
//       console.log('compute isClosedLW for: ' + this.id, 'liveBettingDataSourceType:', this.liveBettingDataSourceType, 'marketLiveWire:', this.marketLiveWire)
      let self = this
      const isLiveClosed = function () {
        let isClosed = false
        if (!self.marketLiveWire) {
           // console.log('No live market')
          isClosed = true
        } else {
          if (self.marketLiveWire['@deleted']) {
//              console.log('Market deleted')
            isClosed = true
          } else if (self.liveBettingDataSourceType === 'PUSH' && self.marketLiveWire && self.marketLiveWire.idfobolifestate === 'C') {
            // console.log('self.marketLiveWire.idfobolifestate:', self.marketLiveWire.idfobolifestate)
            isClosed = true
          } else if (self.liveBettingDataSourceType === 'PUSH' && (!self.marketLiveWire.selections || (self.marketLiveWire.selections && !self.marketLiveWire.selections.length))) {
             // console.log('No live selections')
            isClosed = true
          } else if (self.marketLiveWire.selections && self.marketLiveWire.selections.length) {
            let sl = self.marketLiveWire.selections.find(function (s) {
              return s.idfoselection === self.id
            })
            if (!sl || (sl && !sl.currentpriceup)) {
               // console.log('Empty live selection')
              isClosed = true
            }
          }
        }
        return isClosed
      }
      //
      let closed = (this.isLive || this.isLiveWireEvent) && !this.currentBetSlipState ? isLiveClosed() : undefined
      /*
       if (closed) {
       console.log('compute closed for (' + this.id + '): ' + closed)
       console.log(self.marketLiveWire)
       }
       if (this.closeCheck && !closed) {
       console.log('compute closed for (' + this.id + '): ' + closed)
       }
       */
      // console.log('compute closed for: ' + this.id, ':', closed)
      return closed
    },
    closed () {
      return this.selection && this.selection.isclosed
    },
    isSuspendedLW () {
      // console.log('Compute isSuspendedLW')
      return (this.isLive || this.isLiveWireEvent) && !this.currentBetSlipState ? this.marketLiveWire && !this.isClosedLW && !this.marketLiveWire.istradable : undefined
    },
    istradable () {
      let istradable = this.selection && this.selection.istradable
      // console.log('compute istradable: ' + istradable, this.selection.name)
      return istradable
    },
    suspended () {
      let suspended = this.selection && !this.selection.isclosed && !this.selection.istradable
      // console.log('compute suspended:', suspended, this.selection.name, ';isclosed:', this.selection.isclosed, ';istradable:', this.selection.istradable)
      return suspended
    },
    isClosed () {
      return this.selection && this.selection.isclosed
    },
    isSuspended () {
      return this.selection && !this.selection.isclosed && (!this.selection.istradable || this.isSuspendedViaKilswitch || this.isNR || this.selectionHasSuspensionPerBusinessChannel || this.isSuspendedByCalc)
    },
    interRelated () {
      return store.getters['sbBetslipState/interRelated']
    },
    isInterRelated () {
      return this.interRelated && this.interRelated[this.id]
    },
    isOddsBoost () {
      var selection = this.selection
      return selection && selection.csvpricetypes && this.ksPriceTypeCsvToArray(selection.csvpricetypes).includes('XP') &&
        ((selection.estimatepricedown && selection.estimatepriceup) || selection.isInjectedFrom3rdParty)
    },
    isForSinglesOnly () {
      return this.selection && this.selection.csvavailablebettypes && this.selection.csvavailablebettypes.length === 1 && this.selection.csvavailablebettypes[0] === 'S'
    },
    disableOptedIn () {
      return this.currentBetSlipState > 0 || this.isForSinglesOnly
    },
    isBBenabled () {
      return store.getters['sbBetslipState/isBBenabled']
    },
    isForBB () {
      return this.isBBenabled && this.selection && this.selection.isForBB
    },
    showEventTsStart () {
      return store.getters['sbBetslipState/showEventTsStart']
    },
    popularParlaySelection () {
      let iDFWMarketGroup = this.selection && this.selection.popularParlay && this.selection.popularParlay.iDFWMarketGroup
      return this.id && this.selection ? store.getters['popularParlaysState/getPopularParlaySelection'](this.id, iDFWMarketGroup) : {}
    },
    popularParlaySelectionPrice () {
      let selection = this.popularParlaySelection
      // let price = selection && (selection.price || parseFloat(1 + selection.currentpriceup / selection.currentpricedown))
      let price = selection && selection.price
      if (selection.currentpricedown && selection.currentpriceup) {
        price = this.formatSelectionPrice(selection)
      } else {
        price = priceFormat.formatOdds(price)
      }
      return price
    },
    popularParlaySelectionHandicap () {
      var selection = this.popularParlaySelection
      // var hcp = selection && selection.currenthandicap
      var hcp = selection && hcpFormat.formatHandicap(selection)
      return hcp
    },
    updateBetSlipComplete () {
      return store.getters['sbBetslipState/updateBetSlipComplete']
    },
    loadPopularParlaysComplete () {
      return store.getters['popularParlaysState/loadPopularParlaysComplete']
    },
    useSelectionTeaserInfos () {
      return store.getters['sbBetslipState/useSelectionTeaserInfos']
    },
    betPlacementFinished () {
      return store.getters['sbBetslipState/betPlacementFinished']
    }
  },

  methods: {
    wbr (input, id) {
      input = input || ''
      var i
      var separator
      var separators = ['@', 'v', 'V', 'vs', 'VS', 'Vs', 'At', 'at', 'v.', 'V.', 'vs.', 'VS.', 'Vs.', '-']
      var parts = []
      for (i = 0; i < separators.length; i++) {
        separator = separators[i]
        parts = input ? input.split(' ' + separator + ' ') : []
        if (parts.length === 2) {
          parts[0] += ' ' + separator + ' '
          break
        }
      }
      return parts[id] || ''
    },
    removeSelection (s) {
      store.dispatch('sbBetslipState/toggleBetslipSelection', { 'selection': s, 'sendgtmevent': true })
    },
    formatSelectionPrice (selection) {
      let isoutright = this.market && this.market.isoutright
      return priceFormat.formatSelectionPrice(selection, isoutright)
    },
    priceNum (v, noPrecision) {
      const fractionStrToDecimal = str => str.split('/').reduce((p, c) => p / c)
      if (v) {
        if (typeof v === 'string') {
          v = fractionStrToDecimal(v)
          v = parseFloat(v)
        }
        if (!noPrecision) {
          v = parseFloat(v.toFixed(2))
        }
      }
      return v
    },
    numValue (val) {
      if (val && typeof val === 'string') {
        val = parseFloat(val)
      }
      return val
    },
    checkDerivative (obj) {
      if (this.isSGM) {
        return
      }
      var self = this
      let key = obj.key
      self.changed[key] = self.changed[key] || 0
      self.changed[key]++
      clearTimeout(self.timeOutsDrv[key])
      self.timeOutsDrv[key] = setTimeout(function () {
        // console.log('checkDerivative')
        store.dispatch('sbBetslipState/updateDerivative', {selection: self.selection, changed: self.changed})
        self.changed = {}
      }, 0)
    },
    setBetSlipChange (obj) {
      // console.log('SETBETSLIPCHANGE:', this.selection.name, ':', obj.key, '; ', obj.oldVal, '=>', obj.newVal, 'caller:', obj.caller)
      let self = this
      // let key = obj.key
      // self.changed[key] = self.changed[key] || 0
      // self.changed[key]++
      clearTimeout(self.timeOuts[obj.key])
      self.timeOuts[obj.key] = setTimeout(function () {
        store.dispatch('sbBetslipState/setBetSlipChange', obj)
        store.dispatch('sbBetslipState/scheduleGetABTnR', 0.1)
        // self.changed = {}
      }, 0)
    },
    updateOptedIn (sport) {
      // console.log('updateOptedIn')
      store.dispatch('sbBetslipState/scheduleGetABTnR', 0.000016)
    },
    updateTeaserInfo () {
      // console.log('updateTeaserInfoS')
      if (this.selection && this.selection.teaserinfos) {
        let hcp = hcpFormat.getHandicap(this.selection)
        for (let ts of this.selection.teaserinfos) {
          let hcpT = hcpFormat.getTeaserHcp(hcp, ts)
          Vue.set(ts, 'currenthandicap', hcpT)
        }
      }
    },
    triggerPopularParlaysReload (newVal, oldVal, caller) {
      if (oldVal && typeof newVal !== 'undefined' && newVal !== '' && this.popularParlaySelection && this.popularParlaySelection.idfoselection) {
        if (!this.triggeredBetSlipUpdate) {
          // console.log('triggerPopularParlaysReload by', caller, 'change:', oldVal, '=>', newVal)
          this.triggeredPopularParlaysUpdate = true
          store.commit('popularParlaysState/triggerPopularParlaysReload')
        }
      }
    }
  },

  created () {
  },

  mounted () {
  },

  watch: {
    derivativeSelection (newVal, oldVal) {
      var self = this
      if (newVal.active !== oldVal.active) {
        Vue.set(self, 'doNotMarkChanges', true)
        setTimeout(function () {
          self.doNotMarkChanges = false
          Vue.set(self, 'doNotMarkChanges', false)
        }, 300)
      }
    },
    allowedBetTypesAndReturns: {
      immediate: true,
      handler (newVal, oldVal) {
        // console.log('Watch allowedBetTypesAndReturns')
        let val = (newVal && (newVal[this.derivativeId] || newVal[this.id])) || {}
        // val = JSON.parse(JSON.stringify(val))
        // delete val.Vouchers
        Vue.set(this, 'allowedBetTypesAndReturn', val)
      }
    },
    price: {
      immediate: true,
      handler (newVal, oldVal) {
        var doUpdate = false
        newVal = this.priceNum(newVal)
        oldVal = this.priceNum(oldVal)
        // console.log('WATCHER: selection.priceLocal (tab: ' + this.tab + '): ' + oldVal + ' => ' + newVal)
        if (!this.doNotMarkChanges) {
          if (newVal > oldVal) {
            doUpdate = true
            this.priceUp = this.tab !== 'TEASER' && true
            this.priceDown = false
          } else if (newVal < oldVal) {
            doUpdate = true
            this.priceUp = false
            this.priceDown = this.tab !== 'TEASER' && true
          } else {
            this.priceUp = false
            this.priceDown = false
          }
        } else {
          this.priceUp = false
          this.priceDown = false
        }
        //
        // console.log('WATCHER: selection.priceLocal (tab: ' + this.tab + '): ' + oldVal + ' => ' + newVal, '; currentBetSlipState:', this.currentBetSlipState, '; doUpdate:', doUpdate)
        if (doUpdate && this.currentBetSlipState < this.stateLimitToUpdate && this.tab !== 'TEASER') {
          this.setBetSlipChange({key: 'price', id: this.id, oldVal, newVal, caller: 'Watch-price'})
        }
        if (this.currentBetSlipState < this.stateLimitToUpdate) {
          this.triggerPopularParlaysReload(newVal, oldVal, 'ODDS')
        }
      }
    },
    priceLive: {
      immediate: true,
      handler (newVal, oldVal) {
        // console.log('WATCHER: selection.priceLive: ' + oldVal + ' => ' + newVal)
        if (this.currentBetSlipState < this.stateLimitToUpdate && typeof newVal === 'number') {
          if (newVal && this.selection) {
            Vue.set(this.selection, 'price', this.liveSelection.price)
            Vue.set(this.selection, 'currentpriceup', this.liveSelection.currentpriceup)
            Vue.set(this.selection, 'currentpricedown', this.liveSelection.currentpricedown)
            //
            // this.selection.isPitcherSource || this.selection.isBuyPointsSource
            if (this.tab !== 'TEASER' && (oldVal || this.betPlacementFinished)) {
              this.checkDerivative({key: 'price', id: this.id, checkDerivative: true})
            }
          }
        }
      }
    },
    handicap: {
      immediate: true,
      handler (newVal, oldVal) {
        // console.log('Watch hcp: ' + oldVal + ' => ' + newVal, 'triggeredBetSlipUpdate:', this.triggeredBetSlipUpdate)
        var self = this
        var doUpdate = false
        newVal = self.numValue(newVal)
        oldVal = self.numValue(oldVal)
        if (!self.doNotMarkChanges && self.selection && self.selection.hadvalue && typeof oldVal === 'number' && typeof newVal === 'number') {
          if (newVal > oldVal) {
            doUpdate = true
            self.hcpUp = true
            self.hcpDown = false
          } else if (newVal < oldVal) {
            doUpdate = true
            self.hcpUp = false
            self.hcpDown = true
          } else {
            self.hcpUp = false
            self.hcpDown = false
          }
        } else {
          self.hcpUp = false
          self.hcpDown = false
        }
        // console.log('Watch hcp: ' + oldVal + ' => ' + newVal, 'triggeredBetSlipUpdate:', this.triggeredBetSlipUpdate, '; currentBetSlipState:', this.currentBetSlipState, '; doUpdate:', doUpdate)
        if (doUpdate && this.currentBetSlipState < this.stateLimitToUpdate && this.tab !== 'SGM') {
          this.setBetSlipChange({key: 'currenthandicap', id: this.id, oldVal, newVal, caller: 'Watch-handicap'})
        }
        if (this.currentBetSlipState < this.stateLimitToUpdate && this.tab !== 'SGM') {
          this.triggerPopularParlaysReload(newVal, oldVal, 'HCP')
        }
        this.updateTeaserInfo()
      }
    },
    handicapLive: {
      immediate: true,
      handler (newVal, oldVal) {
        // console.log('Watch handicapLive: ' + oldVal + ' => ' + newVal, '.betPlacementFinished:', this.betPlacementFinished)
        if (this.currentBetSlipState < this.stateLimitToUpdate && typeof newVal === 'number') {
          if (this.selection) {
            Vue.set(this.selection, 'currenthandicap', this.liveSelection.currenthandicap)
            Vue.set(this.selection, 'currentmatchhandicap', this.liveSelection.currenthandicap)
            //
            if (oldVal || this.betPlacementFinished) {
              this.checkDerivative({key: 'currenthandicap', id: this.id, checkDerivative: true})
            }
          }
        }
      }
    },
    /*
    closed: {
      immediate: true,
      handler (newVal, oldVal) {
//          console.log('Watch: closed: ' + oldVal + ' => ' + newVal)
        this.closeCheck = newVal
        if (this.currentBetSlipState < this.stateLimitToUpdate && typeof newVal === 'boolean') {
          if (this.selection.isclosed !== newVal) {
            this.setBetSlipChange({key: 'closed', id: this.selectionId, remove: !newVal, oldVal, newVal, caller: 'Watch-closed'})
          }
          Vue.set(this.selection, 'isclosed', newVal)
        }
      }
    },
    suspended: {
      immediate: true,
      handler (newVal, oldVal) {
        // console.log('Watch: suspended: ' + oldVal + ' => ' + newVal, '; CBSS:', this.currentBetSlipState, this.selection.name)
        if (this.currentBetSlipState < this.stateLimitToUpdate && typeof newVal === 'boolean') {
          // console.log('Watch: suspended: ' + oldVal + ' => ' + newVal, '; CBSS:', this.currentBetSlipState, this.selection.name)
          if (this.selection.istradable !== !newVal) {
            this.setBetSlipChange({key: 'suspended', id: this.selectionId, remove: !newVal, oldVal, newVal, caller: 'Watch-suspended'})
          }
          Vue.set(this.selection, 'istradable', !newVal)
        }
      }
    },
    */
    closed: {
      immediate: !true,
      handler (newVal, oldVal) {
        // console.log('Watch: closed: ' + oldVal + ' => ' + newVal)
        this.closeCheck = newVal
        if (this.currentBetSlipState < this.stateLimitToUpdate && typeof newVal === 'boolean') {
          this.setBetSlipChange({key: 'closed', id: this.selectionId, remove: !newVal, oldVal, newVal, caller: 'Watch-closed'})
        }
      }
    },
    isClosed: {
      immediate: !true,
      handler (newVal, oldVal) {
        // console.log('Watch: closed: ' + oldVal + ' => ' + newVal)
        this.closeCheck = newVal
        if (this.currentBetSlipState < this.stateLimitToUpdate && typeof newVal === 'boolean') {
          this.setBetSlipChange({key: 'closed', id: this.selectionId, remove: !newVal, oldVal, newVal, caller: 'Watch-isClosed'})
        }
      }
    },
    suspended: {
      immediate: !true,
      handler (newVal, oldVal) {
        // console.log('Watch: suspended: ' + oldVal + ' => ' + newVal, 'selection.istradable:', this.selection.istradable, '; CBSS:', this.currentBetSlipState, this.selection.name)
        if (this.currentBetSlipState < this.stateLimitToUpdate && typeof newVal === 'boolean') {
          this.setBetSlipChange({key: 'suspended', id: this.selectionId, remove: !newVal, oldVal, newVal, caller: 'Watch-suspended'})
        }
      }
    },
    isSuspended: {
      immediate: !true,
      handler (newVal, oldVal) {
        // console.log('Watch: isSuspended: ' + oldVal + ' => ' + newVal, 'selection.istradable:', this.selection.istradable, '; CBSS:', this.currentBetSlipState, this.selection.name)
        if (this.currentBetSlipState < this.stateLimitToUpdate && typeof newVal === 'boolean') {
          this.setBetSlipChange({key: 'suspended', id: this.selectionId, remove: !newVal, oldVal, newVal, caller: 'Watch-isSuspended'})
        }
      }
    },
    selectionHasSuspensionPerBusinessChannel: {
      immediate: true,
      handler (newVal, oldVal) {
        // console.log('Watch: selectionHasSuspensionPerBusinessChannel: ' + newVal)
        if (newVal !== this.selection.selectionHasSuspensionPerBusinessChannel) {
          this.setBetSlipChange({key: 'suspended', id: this.selectionId, remove: false, oldVal, newVal, caller: 'Watch-selectionHasSuspensionPerBusinessChannel'})
        }
        // Vue.set(this.selection, 'selectionHasSuspensionPerBusinessChannel', newVal)
        this.selection.selectionHasSuspensionPerBusinessChannel = newVal
      }
    },
    isClosedLW: {
      immediate: true,
      handler (newVal, oldVal) {
        // console.log('Watch: isClosedLW: ' + oldVal + ' => ' + newVal, '; CBSS:', this.currentBetSlipState, this.selection.name)
        if (this.currentBetSlipState < this.stateLimitToUpdate && this.selection && typeof newVal === 'boolean') {
          // console.log('Watch: isClosedLW: ' + oldVal + ' => ' + newVal, '; CBSS:', this.currentBetSlipState, this.selection.name)
          Vue.set(this.selection, 'isclosed', newVal)
        }
      }
    },
    isSuspendedLW: {
      immediate: true,
      handler (newVal, oldVal) {
        // console.log('Watch: isSuspendedLW: ' + oldVal + ' => ' + newVal, '; CBSS:', this.currentBetSlipState, '; istradable:', this.selection.istradable, this.selection.name, '; istradable', this.selection.istradable)
        if (this.currentBetSlipState < this.stateLimitToUpdate && this.selection && typeof newVal === 'boolean') {
          // console.log('Watch: isSuspendedLW: ' + oldVal + ' => ' + newVal, '; CBSS:', this.currentBetSlipState, '; istradable:', this.selection.istradable, this.selection.name, '; istradable', this.selection.istradable)
          Vue.set(this.selection, 'istradable', !newVal)
        }
      }
    },
    activepricetypesLW: {
      immediate: true,
      handler (newVal, oldVal) {
        // console.log('Watch: activepricetypesLW: ' + oldVal + ' => ' + newVal, '; CBSS:', this.currentBetSlipState, this.selection.name)
        if (this.currentBetSlipState < this.stateLimitToUpdate && this.selection && typeof newVal === 'string') {
          // Vue.set(this.selection, 'csvpricetypes', newVal.split(','))
          this.selection.pricetypecsv = newVal
          this.selection.csvpricetypes = newVal.split(',')
          store.commit('sbBetslipState/setPriceType', this.selection)
        }
      }
    },
    csvpricetypes: {
      immediate: true,
      handler (newVal, oldVal) {
        // console.log('Watch: csvpricetypes: ' + oldVal + ' => ' + newVal, '; CBSS:', this.currentBetSlipState, this.selection.name)
        if (this.currentBetSlipState < this.stateLimitToUpdate) {
          this.setBetSlipChange({key: 'csvpricetypes', id: this.selectionId, remove: false, oldVal, newVal})
        }
      }
    },

    popularParlaySelection: {
      immediate: true,
      handler (newVal, oldVal) {
        // console.log('Watch popularParlaySelection:', oldVal, '=>', newVal, this.selection.idfoselection, 'triggeredPopularParlaysUpdate:', this.triggeredPopularParlaysUpdate, new Date().getTime())
        if (this.selection && !oldVal && newVal && newVal.idfoselection && this.currentBetSlipState < this.stateLimitToUpdate) {
          let hcp = this.handicap
          let teaserSelection = null
          if (this.tab === 'TEASER') {
            let selection = this.selection
            if (this.useSelectionTeaserInfos) {
              let teaserinfos = selection.teaserinfos || []
              teaserSelection = teaserinfos.find(t => t.idfoselection === newVal.idfoselection)
            } else {
              teaserSelection = this.id && selection.activeDerivative && selection.isTeaserSource ? store.getters['sbBetslipState/teaserSelection'](selection.isTeaserSource, this.id) : {}
            }
            if (teaserSelection && teaserSelection.idfoselection) {
              hcp = hcpFormat.formatHandicap(teaserSelection)
            }
          }
          //
          if ((this.tab !== 'TEASER' && this.price && this.price !== this.popularParlaySelectionPrice) ||
            ((this.tab !== 'TEASER' || teaserSelection) && hcp && hcp !== this.popularParlaySelectionHandicap)) {
            // console.log('on PopularParlay Selection Load - triggerPopularParlaysReload', this.selectionId)
            store.commit('popularParlaysState/triggerPopularParlaysReload')
          }
        }

        if (!this.triggeredPopularParlaysUpdate) {
          if (this.selection && oldVal && newVal && newVal.idfoselection && this.currentBetSlipState < this.stateLimitToUpdate) {
            if ((newVal.price && newVal.price !== oldVal.price) || (newVal.currenthandicap && newVal.currenthandicap !== oldVal.currenthandicap)) {
              // console.log('Watch popularParlaySelection:', oldVal, '=>', newVal, '=> scheduleBetSlipUpdate')
              this.triggeredBetSlipUpdate = true
              Vue.set(this.selection, 'selectionhashcode', 0)
              store.dispatch('sbBetslipState/scheduleBetSlipUpdate', 0.103)
            }
          }
        }
      }
    },
    updateBetSlipComplete (newVal, oldVal) {
      // console.log('WATCHER: updateBetSlipComplete: ' + oldVal + ' => ' + newVal, this.selectionId, 'triggeredBetSlipUpdate:', this.triggeredBetSlipUpdate)
      if (this.triggeredBetSlipUpdate) {
        setTimeout(() => {
          // console.log('RESET triggeredBetSlipUpdate')
          this.triggeredBetSlipUpdate = false
        }, 10)
      }
    },
    loadPopularParlaysComplete (newVal, oldVal) {
      // console.log('WATCHER: loadPopularParlaysComplete: ' + oldVal + ' => ' + newVal, this.selectionId, 'loadPopularParlaysComplete:', this.loadPopularParlaysComplete)
      if (this.triggeredPopularParlaysUpdate) {
        setTimeout(() => {
          // console.log('RESET triggeredPopularParlaysUpdate')
          this.triggeredPopularParlaysUpdate = false
        }, 10)
      }
    },

    clearMarkings (clear) {
      var self = this
      if (clear) {
        self.priceUp = false
        self.priceDown = false
        self.hcpUp = false
        self.hcpDown = false
      }
    }
  },

  destroyed () {
  }
}



// WEBPACK FOOTER //
// ./src/components/sports/BetSlipV2/mixins/selection.js